import Vue from 'vue';
import axios from 'axios'; 

export default {
  name: 'GisUsersSettings',
  data: function () {
    return {
      maps: [],
      mapId: -1,
      isInComm: false,
      message: '',
      selectedMap: '',
      layers: [],
    }
  },
  watch: {
    selectedMap: function (value) {
      this.getMapLayersCompatibility();
    }
  },
  created() {
    this.getMaps();
    this.getDefaultMap();
  },
  methods: {
    getMaps() {
      //axios.post('/GIS/GetMaps')
      //  .then(response => {
      //    if (response.data.data.status == 0) {
      //      this.maps = response.data.items;
      //      if (this.mapId < 0 && this.maps.length == 1)
      //        this.mapId = this.maps[0].id;
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text);
      //    }
      //  })
      //  .catch(e => { this.$router.push('/login'); return false; })

      axios.post('/GIS/GetMapsOld')
        .then(response => {
          if (response.data.data.status == 0) 
            this.maps = response.data.items;
          else 
            this.$alertMsg(response.data.data.text);
        })
        .catch(e => { this.$router.push('/login'); return false; })

    },
    getDefaultMap() {
      //axios.post('/GIS/GetDefaultMap')
      //  .then(response => {
      //    if (response.data.data.status == 0) 
      //      this.mapId = response.data.mapId;
      //    else 
      //      this.$alertMsg(response.data.data.text);
      //  })
      //  .catch(e => { this.$router.push('/login'); return false; })

      axios.post('/GIS/GetDefaultMapOld')
        .then(response => {
          if (response.data.data.status == 0)
          {
            this.selectedMap = response.data.map;
            this.getMapLayersCompatibility();
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    saveDefaultMap() {
      this.isInComm = true;
      //axios.post('/GIS/SaveDefaultMap', { Value: this.mapId })
      //  .then(response => {
      //    if (response.data.data.status == 0) {
      //      this.closeWithMessage('Default map saved successfully', 0, 1500);
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text);
      //    }
      //    this.isInComm = false;
      //  })
      //  .catch(e => { this.$router.push('/login'); return false; })

      axios.post('/GIS/SaveDefaultMapOld', { Value: this.selectedMap })
        .then(response => {
          if (response.data.data.status == 0) {
            this.closeWithMessage(this.$t('messages.DefaultMapSavedSuccess'), 0, 1500);
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
          this.isInComm = false;
        })
        .catch(e => { this.$router.push('/login'); return false; })

    },
    getMapLayersCompatibility() {
      if (this.selectedMap != '') {
        axios.post('/GIS/GetMapLayersCompatibilityOld', { Value: this.selectedMap })
          .then(response => {
            if (response.data.data.status == 0)
              this.layers = response.data.items;
            else
              this.$alertMsg(response.data.data.text);
          })
          .catch(e => { this.$router.push('/login'); return false; })
      }
      else
        this.layers = [];
    },
    
    close() {
      this.$router.go(-1);
    },
    closeWithMessage(msg, type, timeout = 3000) {
      this.message = msg;
      if (type == 1)
        this.message += ' If the problem repeats please contact Support';
      this.$alertMsg(msg);
      setTimeout(function () { this.close(); }.bind(this), timeout);
    },
  },
}
